const React = require("react");
const T = require("prop-types");
const Snackbar = require("containers/Snackbar");
const Header = require("containers/Header");
const Classes = require("./styles.scss");
const Footer = require("components/Footer");

// Pull global styles
require("../../styles/core.scss");

const internals = {};

const CoreLayout = ({ children }) => (
    <div className={Classes.appContainer}>
        <Header />
        <div className={Classes.mainContainer}>{children}</div>
        <Snackbar />
        <Footer />
    </div>
);

CoreLayout.propTypes = {
    children: T.element.isRequired
};

module.exports = CoreLayout;



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/index.js